var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-width":"400px","height":"400px"},attrs:{"id":"container"}}),_c('p',[_vm._v("*Click different sets in the Venn plot to obtain corresponding data in the table below."),_c('br')])])
}]

export { render, staticRenderFns }